import React, { useState, useEffect } from "react";
import { FormInput, FormSelect, Row, Col, Button } from "shards-react";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import styled from "styled-components";

const Table26 = (props) => {
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const [onEditCurrent, setOnEditCurrent] = useState(
    props.type === "edit" ? false : true
  );
  const [PowerbiData, setPowerbiData] = useState(null);
  const [companyList, setCompany] = useState(null);
  const [countryList, setcountryList] = useState(null);
  const [exibitionsList, setExibitions] = useState(null);
  const [groupList, setGroup] = useState(null);
  const [projectList, setProject] = useState(null);
  const [typeinvestmentList, setTypeinvestment] = useState(null);

  const axios = require("axios").default;
  //4 สร้างข้อมูลเพื่อส่งไปอนุมัติ
  const onCeateTable = () => {
    const obj = [];
    PowerbiData.map((item, index) => {
      const data = { ...item };
      data.yearId = props.yearId;
      delete data.id;
      delete data.createDate;
      delete data.lastUpdate;
      delete data.tableHeadId;
      delete data.id;
      obj.push(data);
    });
    const filter = obj.filter(
      (item) =>
        item.fillValue === "" ||
        item.fillValue === null ||
        item.target === "" ||
        item.target === null
    );
    console.log("@PowerbiData", filter);
    if (filter.length > 0) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      return false;
    }
    props.onCeateTable(obj);
  };

  const getCurrentData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId || null,
        tableHeadId: props.listheadId || null,
        yearNo: props.newHeadId ? null : Number(props.yearNo),
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        if (response.data.data.length > 0) {
          if (response.data.data[0].list.length == 0) {
            getNewData();
          } else {
            setLoading(false);
            const dataView = response.data.data[0].list.map((item) => {
              let data = { ...item };
              if (props.type === "new" && props.newHeadId) {
                if (response.data.data[0].yearId != props.yearId) {
                  data.fillValue = "";
                  data.target = "";
                }
              }
              return data;
            });
            if (
              props.type == "new" &&
              response.data.data[0].yearId != props.yearId &&
              props.tableTabSettingId == 56
            ) {
              const dataNew = [...dataView];
              setPowerbiData([dataNew[0]]);
            } else {
              setPowerbiData(dataView);
            }
          }
        } else {
          setLoading(false);
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getNewData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId,
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        setLoading(false);
        if (response.data.data.length > 0) {
          const dataView = response.data.data[0].list.map((item) => {
            let data = { ...item };
            data.fillValue = "";
            data.target = "";
            return data;
          });
          setPowerbiData(dataView);
        } else {
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const table21Country = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table21/table21Country`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        console.log("setcountryList", response.data);
        setcountryList(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table21/table21Country", error);
      });
  };

  const getCompany = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table26/table26company`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        console.log("Company", response.data);
        setCompany(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table26/table26company", error);
      });
  };

  const getExibitions = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table26/table26exibitions`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setExibitions(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table26/table26exibitions", error);
      });
  };

  const getGroup = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table26/table26group`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setGroup(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table26/table26group", error);
      });
  };

  const getProject = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table26/table26project`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setProject(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table26/table26project", error);
      });
  };

  const getTypeinvestment = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table26/table26typeinvestment`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setTypeinvestment(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table26/table26typeinvestment", error);
      });
  };

  useEffect(() => {
    getCompany();
    getExibitions();
    getGroup();
    getProject();
    getTypeinvestment();
    table21Country();
    getCurrentData();
  }, []);

  useEffect(() => {
    getCurrentData();
  }, [props.yearId]);

  const onAddRowTable = () => {
    let datas = [...PowerbiData];
    const data = { ...datas[0] };
    data.fillValue = "";
    data.growth = "";
    setPowerbiData(datas.concat([data]));
  };

  const onSetdata = (index, dataName, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index][dataName] = value;
    setPowerbiData(newTodos);
  };

  return (
    <Row>
      {props.tableTabSettingId == 55 && (
        <Col
          md="12"
          style={{
            overflowX: "auto",
            display: "block",
          }}
        >
          <table className="table mb-0">
            <thead className="thead-dark">
              <tr>
                <th scope="col">NO</th>
                <th scope="col">Project</th>
                <th scope="col">Exibitions</th>
                <th scope="col">Value</th>
                <th scope="col">Target</th>
              </tr>
            </thead>
            {loading ? (
              <tbody className="table-middle">
                <tr>
                  <td colSpan={4}> Loading... </td>
                </tr>
              </tbody>
            ) : PowerbiData != null && PowerbiData.length > 0 ? (
              <tbody className="table-middle">
                {PowerbiData.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      <FormSelect
                        placeholder="- เลือก -"
                        value={item.projectId}
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "projectId", e.target.value);
                        }}
                        require
                      >
                        {projectList != null &&
                          projectList.length > 0 &&
                          projectList.map((item) => {
                            return (
                              <option value={item.projectId}>
                                {item.projectName}
                              </option>
                            );
                          })}
                      </FormSelect>
                    </td>
                    <td>
                      <FormSelect
                        placeholder="- เลือก -"
                        value={item.exibitionsId}
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "exibitionsId", e.target.value);
                        }}
                        require
                      >
                        {exibitionsList != null &&
                          exibitionsList.length > 0 &&
                          exibitionsList.filter(ex => ex.projectId == item.projectId).map((item) => {
                            return (
                              <option value={item.exibitionsId}>
                                {item.exibitionsName}
                              </option>
                            );
                          })}
                      </FormSelect>
                    </td>
                    <td>
                      <FormInput
                        type="number"
                        value={item.fillValue}
                        disabled={!onEditCurrent}
                        placeholder="fillValue"
                        onChange={(e) => {
                          onSetdata(index, "fillValue", e.target.value);
                        }}
                        require
                      />
                    </td>
                    <td>
                      <FormInput
                        type="number"
                        value={item.target}
                        disabled={!onEditCurrent}
                        placeholder="target"
                        onChange={(e) => {
                          onSetdata(index, "target", e.target.value);
                        }}
                        require
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody className="table-middle">
                <tr>
                  <td colSpan={4}> ไม่มีข้อมูล </td>
                </tr>
              </tbody>
            )}
          </table>
        </Col>
      )}

      {props.tableTabSettingId == 56 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5 style={{ float: "left" }}>
              จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
              แถว
            </h5>

            {props.type === "edit" ? (
              onEditCurrent && (
                <Button
                  theme="success"
                  onClick={() => onAddRowTable()}
                  style={{ float: "right", width: 200 }}
                >
                  เพิ่มแถว
                </Button>
              )
            ) : (
              <Button
                theme="success"
                onClick={() => onAddRowTable()}
                style={{ float: "right", width: 200 }}
              >
                เพิ่มแถว
              </Button>
            )}
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Group</th>
                  <th scope="col">Country</th>
                  <th scope="col">Company_Name</th>
                  <th scope="col">Type_Investment</th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={4}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                    <td>{index + 1}</td>
                    <td>
                      <FormSelect
                        placeholder="- เลือก -"
                        value={item.groupId}
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "groupId", e.target.value);
                        }}
                        require
                      >
                        {groupList != null &&
                          groupList.length > 0 &&
                          groupList.map((item) => {
                            return (
                              <option value={item.groupId}>
                                {item.groupName}
                              </option>
                            );
                          })}
                      </FormSelect>
                    </td>
                    <td>
                      <FormSelect
                        placeholder="- เลือก -"
                        value={item.countryId}
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "countryId", e.target.value);
                        }}
                      >
                        {countryList != null &&
                          countryList.length > 0 &&
                          countryList.map((item) => {
                            return (
                              <option value={item.countryId}>
                                {item.countryName}
                              </option>
                            );
                          })}
                      </FormSelect>
                    </td>
                    <td>
                      <FormSelect
                        placeholder="- เลือก -"
                        value={item.companyId}
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "companyId", e.target.value);
                        }}
                      >
                        {companyList != null &&
                          companyList.length > 0 &&
                          companyList.map((item) => {
                            return (
                              <option value={item.companyId}>
                                {item.companyName}
                              </option>
                            );
                          })}
                      </FormSelect>
                    </td>
                    <td>
                      <FormSelect
                        placeholder="- เลือก -"
                        value={item.typeInvestmentId}
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "typeInvestmentId", e.target.value);
                        }}
                        require
                      >
                        {typeinvestmentList != null &&
                          typeinvestmentList.length > 0 &&
                          typeinvestmentList.map((item) => {
                            return (
                              <option value={item.typeInvestmentId}>
                                {item.typeInvestmentName}
                              </option>
                            );
                          })}
                      </FormSelect>
                    </td>
                  </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={4}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.type === "edit" ? (
        <Col md="12" style={{ padding: "15px" }}>
          {onEditCurrent ? (
            <Button
              theme="success"
              onClick={() => onCeateTable()}
              style={{ float: "right", width: 200 }}
            >
              บันทึกข้อมูล
            </Button>
          ) : props.status == 0 && props.userType != 3 ? (
            <Button
              theme="success"
              onClick={() => props.onApproveTable()}
              style={{ float: "right", width: 200 }}
            >
              อนุมัติเผยแพร่
            </Button>
          ) : null}
          {!onEditCurrent && (
            <Button
              outline
              theme="secondary"
              onClick={() => setOnEditCurrent(true)}
              style={{ float: "right", width: 200, marginRight: 20 }}
            >
              แก้ไขข้อมูล
            </Button>
          )}
        </Col>
      ) : (
        <Col md="12" style={{ padding: "15px" }}>
          <Button
            theme="success"
            onClick={() => onCeateTable()}
            style={{ float: "right", width: 200 }}
          >
            บันทึกข้อมูล
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default Table26;
